module.exports = __webpack_public_path__ + "img/0.f3bad305.png";